import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getRagObjectsAction } from "./actions";
import type { SidebarItemsState } from "./types";

export function getRagObjectsReducerBuilder(
  builder: ActionReducerMapBuilder<SidebarItemsState>
) {
  builder.addCase(getRagObjectsAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getRagObjectsAction.fulfilled, (state, action) => {
    state.ragObjects = action.payload;
    state.isLoading = false;
  });
  builder.addCase(getRagObjectsAction.rejected, (state) => {
    state.isLoading = false;
  });
}
